module.exports = __webpack_public_path__ + "static/media/james.56dc49ab.png";